<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <div class="profile-form">
        <p
          class="profile-label"
          v-if="model.first_name != null"
          style="top: 13px; right: 44px"
        >
          نام
        </p>
        <input
          class="profile-input"
          v-model="model.first_name"
          placeholder="نام"
        />
      </div>
      <div class="profile-form">
        <p class="profile-label" v-if="model.last_name != null">نام خانوادگی</p>
        <input
          class="profile-input"
          v-model="model.last_name"
          placeholder="نام خانوادگی"
        />
      </div>
      <div class="profile-form">
        <p class="profile-label" style="top: 23px" v-if="mobile != null">
          شماره تلفن
        </p>
        <input
          class="profile-input-l"
          v-model="mobile"
          placeholder="شماره تلفن"
        />
      </div>
      <div class="profile-form">
        <p class="profile-label" v-if="model.birthday != null">تاریخ تولد</p>
        <input
          class="profile-input"
          v-model="model.birthday"
          placeholder="تاریخ تولد"
        />
      </div>
      <div class="profile-form">
        <p class="profile-label" style="top: 23px" v-if="email != null">
          پست الکترونیکی
        </p>
        <input
          class="profile-input-l"
          v-model="email"
          placeholder="پست الکترونیکی"
        />
      </div>
      <!-- <div class="profile-form">
        <p class="profile-label" style="top: 23px;" v-if="nationalCode != null"> کدملی </p>
        <input
          class="profile-input-l"
          v-model="nationalCode.national_code"
          placeholder="کدملی"
        />
      </div> -->
      <button
        class="m-btn f-bootom"
        style="margin-top: 14px"
        @click="updateHandler"
      >
        ذخیره
      </button>
      <!-- <button class="m-btn " style="margin-top: 14px" @click="nupdateHandler">nupdateHandler</button> -->
    </div>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  beforeMount() {
    this.getProfile();
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      model: {},
      mobile: null,
      email: null,
      nationalCode: {},
    };
  },
  methods: {
    getProfile() {
      this.$store.dispatch("user/profile").then((rsp) => {
        this.mobile = rsp.mobile;
        this.email = rsp.email;
        this.model.birthday = rsp.birthday;
        this.model.first_name = rsp.first_name;
        this.model.last_name = rsp.last_name;
      });
    },
    updateHandler() {
      this.$store.dispatch("user/updateProfile", this.model).then();
    },
    nupdateHandler() {
      this.$store.dispatch("user/setNationalCode", this.nationalCode).then();
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.profile-label {
  float: right;
  position: relative;
  right: 37px;
  background: #fff;
  padding: 2px;
  font-size: 12px;
  top: 38px;
}
.profile-input {
  direction: rtl;
  width: 90%;
}
.profile-input {
  margin-top: 28px;
}
.f-bootom {
  position: fixed;
  bottom: 22px;
  right: 6px;
  width: 95%;
}
.profile-input-l {
  width: 90%;
}
</style>
